import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GlobalsProvider } from './context/globals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalsProvider>
      <App />
    </GlobalsProvider>
  </React.StrictMode>
);

